export default __webpack_public_path__ + "static/media/monkey-9.d52017b2.png";